var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconChartUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "17 6 65.96 88.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m82.09,92.22h-3.34V30.71c0-.49-.4-.89-.89-.89h-10.79c-.49,0-.89.4-.89.89v61.52h-2.45v-47.5c0-.49-.4-.89-.89-.89h-10.79c-.49,0-.89.4-.89.89v47.5h-2.45v-33.16c0-.49-.4-.89-.89-.89h-10.79c-.49,0-.89.4-.89.89v33.16h-2.45v-18.8c0-.49-.4-.89-.89-.89h-10.79c-.49,0-.89.4-.89.89v18.8h-3.23c-.49,0-.89.4-.89.89s.4.89.89.89h64.18c.49,0,.89-.4.89-.89s-.4-.89-.89-.89Zm-59.18,0v-17.91h9.01v17.91h-9.01Zm15.02,0v-32.27h9.01v32.27h-9.01Zm15.02,0v-46.61h9.01v46.61h-9.01Zm15.02,0V31.6h9.01v60.63h-9.01Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m17.91,62.33c.23,0,.45-.09.63-.26L71.54,9.06v10.77c0,.49.4.89.89.89s.89-.4.89-.89V7.11c.07-.29,0-.62-.23-.85-.18-.18-.41-.26-.64-.26,0,0,0,0-.01,0h-12.94c-.49,0-.89.4-.89.89s.4.89.89.89h10.82L17.28,60.81c-.35.35-.35.91,0,1.26.17.17.4.26.63.26Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChartUp);
export default __webpack_public_path__ + "static/media/icon-chart-up.b6c1a0d509e0499277f01cccc536ed21.svg";
export { ForwardRef as ReactComponent };